




















import HelloWorld from '@/components/HelloWorld.vue'
import Vue from "vue"
import {Component} from "vue-property-decorator"

@Component({
  name: "Home",
  components: {
    HelloWorld
  }
})
export default class Home extends Vue {}
